import { ref } from "vue";
import { defineStore } from "pinia";
import { v4 as uuid } from "uuid";

type Toast = {
  id: string;
  testId: string;
  duration: number;
  title: string;
  message: string;
  variant: "danger" | "info" | "success";
};

export const useToastStore = defineStore("toast", () => {
  const toasts = ref<Toast[]>([]);
  const timeouts = ref<Record<string, NodeJS.Timeout>>({});

  function displayToast(toast: Omit<Toast, "id">) {
    const toastId = uuid();
    toasts.value = [...toasts.value, { ...toast, id: toastId }];

    const timeout = setTimeout(() => {
      closeToast(toastId);
    }, toast.duration);

    timeouts.value[toastId] = timeout;
  }

  function closeToast(id: string) {
    if (timeouts.value[id]) {
      clearTimeout(timeouts.value[id]);
      delete timeouts.value[id];
    }
    toasts.value = toasts.value.filter((toast) => toast.id !== id);
  }

  return { toasts, displayToast, closeToast };
});
